
var menu =  document.getElementById('menu-primary')
if (typeof(menu) != 'undefined' && menu != null)
{
    var btn_open = document.getElementById("menu-primary-mobile-open")
    var btn_close = document.getElementById("menu-primary-mobile-close")
    var menu_mobile = document.getElementById("menu-primary-mobile-wrapper")

    btn_open.onclick = function() {
        menu_mobile.classList.add("show")
    }
    btn_close.onclick = function() {
        menu_mobile.classList.remove("show")
    }
}
